/**
 * Счета и выписки, кредиты и лизинг, планы поступлений ведёт Финансист: в модуле
 * ОСНОВА.Финансист эти экраны открываются для правки, в Пульте Гендиректора — только
 * для просмотра. Данные одни и те же (таблицы ceo_*, API /agents/ceo/*).
 */
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useCeoWriteAccess } from '@entities/user';

/** Можно ли править на экране: только в модуле Финансиста и при праве записи на сервере. */
export function useTreasuryWrite(editable: boolean): boolean {
  const canWrite = useCeoWriteAccess();
  return editable && canWrite;
}

const Note = styled.div`
  font-size: 12px;
  padding: 8px 12px;
  border-radius: ${({ theme }) => theme.radius.md};
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.backgroundElevated};
  color: ${({ theme }) => theme.colors.text.secondary};

  a {
    font-weight: 600;
  }
`;

/** Плашка экрана просмотра в Пульте Гендиректора: где эти данные ведут. */
export function TreasuryViewNote({ section, to }: { section: string; to: string }) {
  return (
    <Note>
      Просмотр. «{section}» ведёт Финансист: <Link to={to}>ОСНОВА.Финансист → «{section}»</Link>.
    </Note>
  );
}
